module.exports = __webpack_public_path__ + "static/media/fragile.45ba94ca.svg";